import React, { useRef, useState } from 'react';

import { Box } from '@chakra-ui/react';
import emotionStyled from '@emotion/styled';
import styled, { css } from 'styled-components';
import { commentEditorStyles, commentPlaceholderStyles } from 'styles/common';
import { checkFeedbackModuleEnabled } from 'utils/helpers/moduleAccess';

import { SEARCH_WIDGET_TYPES } from 'constants/ProjectConstants';
import { isMobileView } from 'constants/isMobileView';

import { PostField } from 'uiToolkitV1/PostField/PostField';

export default function OKREditCommentComponent({
  editorState,
  setEditorState,
  onEnter,
  loading,
  uploadedFile,
  setUploadedFile,
  onEscape,
  MediaPreview,
  UploadTypesView,
  VisibilityComponent,
  TagRecommendations,
  placeholder,
  className,
  handleBlur = null,
  handleFocus = () => {},
  SentimentComponent = null,
  KudosComponent = null,
  enableKudos = true,
  useEmojiFunctionality = true,
  isDisabled = false,
  allowEnterToNextLine = false,
}) {
  const postFieldContainerRef = useRef(null);

  const emojiContainerRef = useRef(null);

  const allowBlurRef = useRef({ allowBlurEvent: true });

  const [emojiPlugin, setEmojiPlugin] = useState(null);

  const showKudosToggle = !!KudosComponent && checkFeedbackModuleEnabled() && enableKudos;
  // onMouseDown fires before onBlur
  // this makes it possible to not fire on blur when clicking on any element under PostFieldContainer
  // such as adding emojis or changing comment visibility
  const onBlurHandler = (e) => {
    if (allowBlurRef.current.allowBlurEvent) {
      handleBlur && handleBlur(e);
    }
    allowBlurRef.current.allowBlurEvent = true;
    return e;
  };

  const onMouseDownHandler = (e) => {
    if (emojiContainerRef.current.contains(e.target)) {
      allowBlurRef.current.allowBlurEvent = false;
    } else {
      allowBlurRef.current.allowBlurEvent = true;
    }
    return e;
  };

  return (
    <div className={className}>
      <PostFieldContainer isDisabled={isDisabled} loading={loading} ref={postFieldContainerRef}>
        <PostField
          placeholder={placeholder && placeholder !== '' ? placeholder : 'Enter Comment'}
          // height="2rem"
          updateEditorState={setEditorState}
          editorState={editorState}
          usePortalForSuggestions
          editorStyles={commentEditorStyles}
          editorChakraStyles={isMobileView() ? { minHeight: '44px!important' } : {}} // reducing the height so that comment component can appear without scroll bar in mobile view
          placeholderStyles={commentPlaceholderStyles}
          useMoneyFunctionality
          useMentionFunctionality
          onEnter={onEnter}
          widgetType={SEARCH_WIDGET_TYPES.comment}
          createNewTagFunctionality={false}
          onEscape={onEscape}
          useEmojiFunctionality={useEmojiFunctionality}
          // focusOnMount // <- to be disabled in new PostField else you'll not have Popover open
          allowNewLine
          allowEnterToNextLine={allowEnterToNextLine}
          handleBlur={onBlurHandler}
          handleFocus={handleFocus}
          setEmojiPlugin={setEmojiPlugin}
          portalParentRef={postFieldContainerRef}
          emojiButtonHeight="24px"
          readOnly={isDisabled}
          module="GOAL"
        />
        {MediaPreview}
        <Box onMouseDown={onMouseDownHandler} cursor={isDisabled ? 'not-allowed' : 'auto'} ref={emojiContainerRef}>
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '4px 8px',
            }}
            pointerEvents={isDisabled ? 'none' : 'auto'}
          >
            {showKudosToggle && KudosComponent}
            {showKudosToggle ? <VerticalDivider /> : null}

            {Boolean(emojiPlugin) && (
              <>{React.cloneElement(UploadTypesView, { EmojiSelect: emojiPlugin?.EmojiSelect })}</>
            )}
            {/* {VisibilityComponent}
            {SentimentComponent} */}
            {TagRecommendations}
          </Box>
        </Box>
      </PostFieldContainer>
    </div>
  );
}

const PostFieldContainer = styled.div`
  border: 1px solid ${(props) => props.theme.palette.borders.lighterGrey};
  border-radius: 4px;
  & .editorContainer {
    cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'auto')};
  }
  ${(props) =>
    props.loading &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}
`;

const VerticalDivider = emotionStyled.span`
  height: 1rem;
  width: 0px;
  border-right: 1px solid ${(props) => props.theme.colors.neutral.CFD7DF};
  margin-left: 0.5rem;
  margin-right: 0.5rem;
`;
